import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { ConfirmDelete } from '../detail/ConfirmDelete';

export const OptionalDeleteDialog: React.FC = () => {
  const { t } = useTranslation(['dream', 'translation']);
  const history = useHistory();

  const onCancelClick = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <Dialog hasHeader={true}>
      <ConfirmDelete
        title={t('dialog_delete_dream_history')}
        description={t('dialog_delete_ask_01')}
        confirm={t('translation:button_delete')}
        onCancelClick={onCancelClick}
      />
    </Dialog>
  );
};
